module.exports = fox._r("fonts/stateoff.woff?c8mros", __webpack_public_path__ + "_/_/_/root/fonts/2k32eBC.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/stateoff.woff?c8mros
// module id = 438
// module chunks = 4